import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { DatePicker } from '@3plearning/react-components';

import {
    activeFiltersPropType,
    dropdownItemPropType
} from '../../../components/report-filters/filter-prop-types';
import {
    SELECTED_DATE,
    SELECTED_STUDENT,
    SELECTED_CLASS,
    SELECTED_GROUP,
    ALL_GROUPS,
    STUDENT_LIST,
    SELECTED_YEAR_GROUP,
    SELECTED_TEACHER
} from '../../../components/report-filters/filter-constants';
import activeFiltersActions from '../../../components/report-filters/redux/active-filters/active-filters-actions';
import css from './student.scss';
import studentActions, {
    PARTICIPATION_STUDENT_RETRIEVED
} from './student-actions';
import studentPropTypes from './student-prop-types';
import TableHeader from '../../../components/table-header/table-header';
import activeFiltersSelectors from '../../../components/report-filters/redux/active-filters/active-filters-selectors';
import ConnectedTopicTables from '../../../components/participation-student/topic-tables/topic-tables';
import FilterHelper from '../../../helpers/filter-helper';
import StudentCertificates from './components/student-certificates';
import Usage from '../../../components/usage/usage';
import certificatesActions from '../../../components/certificates/certificates-actions';
import { ALL_GROUPS_ID } from '../all-classes/all-classes-constants';
import dropdownDataSelectors from '../../../components/report-filters/redux/dropdown-data/dropdown-data-selectors';
/**
 * Student component
 * Displays participation results table, certificates & usage for a single Student
 */
export class Student extends Component {
    static propTypes = {
        activeFilters: activeFiltersPropType,
        getParticipationData: PropTypes.func,
        participationData: studentPropTypes.participationData,
        invalidRequest: PropTypes.string,
        updateActiveFilter: PropTypes.func,
        newCertificatesDownloadStudentByType: PropTypes.func,
        pastCertificatesDownloadByType: PropTypes.func,
        studentDropdownData: PropTypes.shape({
            data: PropTypes.arrayOf(dropdownItemPropType),
            selectedOption: dropdownItemPropType
        })
    };

    constructor(props) {
        super(props);
        this.i18n = window.i18n;
    }

    componentDidMount() {
        const { activeFilters } = this.props;
        if (FilterHelper.shouldLoadStudent(activeFilters)) {
            this.getStudentParticipationData(
                activeFilters[SELECTED_STUDENT].id,
                activeFilters[SELECTED_CLASS].id,
                activeFilters[SELECTED_DATE]
            );
        }
    }

    componentWillReceiveProps(newProps) {
        const {
            activeFilters,
            invalidRequest,
            updateActiveFilter
        } = this.props;
        const {
            activeFilters: newActiveFilters,
            invalidRequest: newInvalidRequest
        } = newProps;

        if (FilterHelper.shouldReloadStudent(activeFilters, newActiveFilters)) {
            this.getStudentParticipationData(
                newActiveFilters[SELECTED_STUDENT].id,
                newActiveFilters[SELECTED_CLASS].id,
                newActiveFilters[SELECTED_DATE]
            );
        }

        if (
            invalidRequest !== newInvalidRequest &&
            newInvalidRequest === PARTICIPATION_STUDENT_RETRIEVED
        ) {
            if (
                newActiveFilters[SELECTED_DATE].type !==
                DatePicker.THIS_SCHOOL_YEAR
            ) {
                updateActiveFilter(SELECTED_DATE, {
                    type: DatePicker.THIS_SCHOOL_YEAR
                });
            }
        }
    }

    getUsageData = (participationData) => {
        if (participationData) {
            const {
                participationInfo: { liveMathsPoints, activityPoints },
                logInInfo: { signIns, timeOnline },
                certificates
            } = participationData;
            return {
                totalGoldBars: certificates.goldBars,
                totalSignIns: signIns,
                totalTimeOnline: timeOnline,
                totalLiveMathsPoints: liveMathsPoints,
                totalCurriculumPoints: activityPoints
            };
        }

        return null;
    };

    getStudentParticipationData(studentId, classId, selectedDateFilter) {
        const { getParticipationData } = this.props;
        getParticipationData(classId, studentId, selectedDateFilter);
    }

    render() {
        const {
            participationData,
            newCertificatesDownloadStudentByType,
            pastCertificatesDownloadByType,
            activeFilters,
            studentDropdownData
        } = this.props;
        const { data: studentsData } = studentDropdownData;
        const selectedGroupId = activeFilters[SELECTED_GROUP].id;
        const selectedStudent = studentsData.find(
            (data) => data.value === activeFilters[SELECTED_STUDENT].id
        );
        return (
            <div className={css.component}>
                <TableHeader
                    title={this.i18n._('Table Header - Participation')}
                />
                <Usage showGoldBars {...this.getUsageData(participationData)} />
                <StudentCertificates
                    selectedClassroomId={activeFilters[SELECTED_CLASS].id}
                    selectedStudentId={
                        selectedStudent && selectedStudent.userId
                    }
                    selectedGroupId={
                        selectedGroupId === ALL_GROUPS
                            ? ALL_GROUPS_ID
                            : selectedGroupId
                    }
                    participationData={participationData}
                    newCertificatesDownloadStudentByType={
                        newCertificatesDownloadStudentByType
                    }
                    pastCertificatesDownloadByType={
                        pastCertificatesDownloadByType
                    }
                    selectedYearGroupId={activeFilters[SELECTED_YEAR_GROUP].id}
                    selectedTeacherId={activeFilters[SELECTED_TEACHER].id}
                />
                <ConnectedTopicTables />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeFilters: activeFiltersSelectors.selectActiveFilters(state),
        participationData: state.participationStudent,
        invalidRequest: state.invalidRequest,
        studentDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            STUDENT_LIST
        )(state)
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getParticipationData: studentActions.getParticipationData,
            updateActiveFilter: activeFiltersActions.updateActiveFilter,
            newCertificatesDownloadStudentByType:
                certificatesActions.newCertificatesDownloadStudentByType,
            pastCertificatesDownloadByType:
                certificatesActions.pastCertificatesDownloadByType
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Student);



// WEBPACK FOOTER //
// ./containers/participation/student/student.js